import { Component, OnInit } from '@angular/core';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ContactService } from './contact.service';
import { IContact } from './contact';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

  faEnvelope = faEnvelope;
  contactForm;

  constructor(private _contactService: ContactService) { 
    this.contactForm = new FormGroup({
      firstName: new FormControl(),
      lastName: new FormControl(),
      email: new FormControl(),
      message: new FormControl()
    });
  }

  ngOnInit() {
  }

  onSubmit(data): void {
    var contact = {
      "firstName" : data.firstName,
      "lastName" : data.lastName,
      "email" : data.email,
      "message" : data.message
    }
    this._contactService.sendMail(contact);
  }

}
